import { render, staticRenderFns } from "./FullMenu.vue?vue&type=template&id=04b79f7c&scoped=true&"
import script from "./FullMenu.vue?vue&type=script&lang=js&"
export * from "./FullMenu.vue?vue&type=script&lang=js&"
import style0 from "./FullMenu.vue?vue&type=style&index=0&id=04b79f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b79f7c",
  null
  
)

export default component.exports